import { Component, OnInit, computed, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { RecipeService } from '../../services/recipe.service';
import { Recipe } from '../../models/recipe.model';

@Component({
  selector: 'app-recipe-list',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './recipe-list.html',
  styleUrl: './recipe-list.scss'
})
export class RecipeList implements OnInit {
  allRecipes: Recipe[] = [];
  isLoading = true;

  selectedTag = signal<string>('All');

  allTags = computed(() => {
    const tagSet = new Set<string>();
    this.allRecipes.forEach(r => r.tags.forEach(t => tagSet.add(t)));
    return ['All', ...Array.from(tagSet)];
  });

  featuredRecipe = computed(() =>
    this.allRecipes.find(r => r.isFeatured)
  );

  filteredRecipes = computed(() => {
    const tag = this.selectedTag();
    const nonFeatured = this.allRecipes.filter(r => !r.isFeatured);
    if (tag === 'All') return nonFeatured;
    return nonFeatured.filter(r => r.tags.includes(tag));
  });

  constructor(private recipeService: RecipeService) {}

  ngOnInit() {
    this.recipeService.getRecipes().subscribe(data => {
      this.allRecipes = data;
      this.isLoading = false;
    });
  }

  selectTag(tag: string) {
    this.selectedTag.set(tag);
  }

  getImgSrc(url: string | undefined): string {
    if (!url) return '';
    return url.startsWith('/uploads/') ? `https://dev.thehuskbakery.com/api${url}` : url;
  }
}
